export default "__VITE_ASSET__Cn9CERA9__"